export const devTitle =
  process.env.NODE_ENV === 'development' ? (
    <h1 style={{ fontSize: '18px', color: 'red' }}>DEV</h1>
  ) : null
